import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class CustomLink extends Component {

    isExternal(url) {
        return /^https?:\/\//.test(url);
    }

    render() {
        return this.isExternal(this.props.to) ?
            <a
                href={this.props.to}
                target="_blank"
                {...this.props}
            />
            :
            <Link {...this.props} />;
    }
}

export default CustomLink;



// WEBPACK FOOTER //
// ./resources/assets/js/elements/CustomLink.js